module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisalreport-editor"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), (_vm.selecting_realestate) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "dialog_container"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('Select_Real_estate_to_be_added')) + " " + _vm._s(_vm.$t('or')) + " "), _c('span', {
      staticClass: "navspan",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewRealEstate()
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('create_a_new_one')))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Existing_Real_estates')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.importRealEstateValue,
        "options": _vm.object_to_array(_vm.realestates),
        "track-by": "id",
        "label": 'full_address',
        "searchable": true
      },
      on: {
        "input": _vm.set_import_realestate
      },
      model: {
        value: (_vm.appraisalreport.importRealEstate),
        callback: function($$v) {
          _vm.appraisalreport.importRealEstate = $$v
        },
        expression: "appraisalreport.importRealEstate"
      }
    })], 1)]), _vm._v(" "), _c('table', {
      staticClass: "dialog_buttons_table"
    }, [_c('tr', [_c('td', [_c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-right": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCancelImportNewRealEstate($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "times",
        "text": '',
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray",
        "min_width": "80px",
        "max_width": "80px"
      }
    })], 1)])]), _vm._v(" "), _c('td', [_c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onImportNewRealEstate({
            id: _vm.appraisalreport.importRealEstate.id
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "check",
        "text": '',
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray",
        "min_width": "80px",
        "max_width": "80px"
      }
    })], 1)])])])])])]) : _vm._e(), _vm._v(" "), (_vm.creating_contact) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "dialog_container"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('Create_new_contact')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Person_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.value,
        "options": _vm.personTypeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ?
          'name_ca' : (_vm.currentLocale === 'en') ?
          'name_en' : 'name_es',
        "searchable": false
      },
      on: {
        "input": _vm.set_contact_person_type
      },
      model: {
        value: (_vm.contact.person_type),
        callback: function($$v) {
          _vm.contact.person_type = $$v
        },
        expression: "contact.person_type"
      }
    })], 1)]), _vm._v(" "), (_vm.contact.person_type) ? _c('div', [_c('div', {
      staticClass: "field-container"
    }, [(_vm.contact.person_type.id === 1) ? _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Title')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.value,
        "options": _vm.honorificTitleOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ?
          'abb_ca' : (_vm.currentLocale === 'en') ?
          'abb_en' : 'abb_es',
        "searchable": false
      },
      on: {
        "input": _vm.set_contact_title
      },
      model: {
        value: (_vm.contact.title),
        callback: function($$v) {
          _vm.contact.title = $$v
        },
        expression: "contact.title"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Name')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.name),
        expression: "contact.name"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.name = $event.target.value
        }, _vm.set_contact_name]
      }
    })]), _vm._v(" "), (_vm.contact.person_type.id === 1) ? _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Surnames')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.surnames),
        expression: "contact.surnames"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.surnames)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.surnames = $event.target.value
        }, _vm.set_contact_surnames]
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Main_email')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.main_email),
        expression: "contact.main_email"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.main_email)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.main_email = $event.target.value
        }, _vm.set_contact_main_email]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('TIN')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.tin),
        expression: "contact.tin"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.tin)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.tin = $event.target.value
        }, _vm.set_contact_tin]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Fiscal_address')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.complete_fiscal_address),
        expression: "contact.complete_fiscal_address"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.complete_fiscal_address)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.complete_fiscal_address = $event.target.value
        }, _vm.set_contact_complete_fiscal_address]
      }
    })])])]) : _vm._e()]), _vm._v(" "), _c('table', {
      staticClass: "dialog_buttons_table"
    }, [_c('tr', [_c('td', [_c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-right": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCancelCreateNewContact($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "times",
        "text": '',
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray",
        "min_width": "80px",
        "max_width": "80px"
      }
    })], 1)])]), _vm._v(" "), _c('td', [_c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewContact($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "check",
        "text": '',
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray",
        "min_width": "80px",
        "max_width": "80px"
      }
    })], 1)])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "fileId": _vm.appraisalfile.id,
        "fileNumber": _vm.appraisalfile.number,
        "reportOpen": _vm.reportOpen,
        "realEstates": _vm.appraisalreport_realestates,
        "reportId": _vm.appraisalreport.id
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Appraisal_report')) + " "), (_vm.appraisalreport.full_number) ? _c('span', [_vm._v(_vm._s(_vm.appraisalreport.full_number))]) : _vm._e(), (_vm.appraisalreport.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.appraisalreport.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.appraisalreport.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.appraisalreport.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.reportcontent_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Title_and_date_of_report')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Report_title'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalreport.title),
        expression: "appraisalreport.title"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalreport.title)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalreport.title = $event.target.value
        }, _vm.set_appraisalreport_title]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Date_of_report'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalreport.reportdate),
        expression: "appraisalreport.reportdate"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "date",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalreport.reportdate)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalreport.reportdate = $event.target.value
        }, _vm.set_appraisalreport_reportdate]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Send_to_bde_q')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Send_to_bde_q')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalreport.send_to_bde),
        expression: "appraisalreport.send_to_bde"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisalreport.send_to_bde) ? _vm._i(_vm.appraisalreport.send_to_bde, null) > -1 : (_vm.appraisalreport.send_to_bde)
      },
      on: {
        "input": _vm.set_appraisalreport_send_to_bde,
        "__c": function($event) {
          var $$a = _vm.appraisalreport.send_to_bde,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisalreport.send_to_bde = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisalreport.send_to_bde = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisalreport.send_to_bde = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Appraisal_petitioners')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container",
      staticStyle: {
        "background-color": "#fafafc",
        "padding": "2rem"
      }
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Surnames_name_or_company'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.petitionerValue,
        "options": _vm.object_to_array(_vm.contacts),
        "track-by": "id",
        "label": 'complete_name',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisalreport_petitioner
      },
      model: {
        value: (_vm.appraisalreport.petitioner),
        callback: function($$v) {
          _vm.appraisalreport.petitioner = $$v
        },
        expression: "appraisalreport.petitioner"
      }
    }, [_c('span', {
      style: ({
        color: _vm.no_result_color
      }),
      attrs: {
        "slot-scope": "props"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onAddNewContact($event)
        },
        "mouseover": function($event) {
          _vm.no_result_color = 'rgb(0, 135, 248)'
        },
        "mouseleave": function($event) {
          _vm.no_result_color = 'black'
        }
      },
      slot: "noResult"
    }, [_vm._v("Cap resultat. Click per crear nou.")])])], 1), _vm._v(" "), (_vm.appraisalreport.petitioner) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onAddNewPetitioner($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.add_petitioner_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (_vm.object_length(_vm.appraisalreport_petitioners) > 0) ? _c('div', [_c('div', {
      staticClass: "text_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-appraisalreport_petitioners",
        "source": _vm.object_to_array(_vm.appraisalreport_petitioners),
        "filterable": false,
        "striped": _vm.petitioner_table.striped,
        "editable": _vm.petitioner_table.editable,
        "line-numbers": _vm.petitioner_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-petitioners",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editContact(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.discardPetitioner(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "times",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_c('datatable-column', {
      attrs: {
        "id": "actions-petitioners",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _vm._l((_vm.petitioner_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    })], 2)], 1)])])]) : _c('div', [_c('br'), _vm._v(_vm._s(_vm.$t('No_petitioners_text')))])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Mandatary')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Entity'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.entityValue,
        "options": _vm.object_to_array(_vm.entities),
        "track-by": "id",
        "label": 'name',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisalreport_entity
      },
      model: {
        value: (_vm.appraisalreport.entity),
        callback: function($$v) {
          _vm.appraisalreport.entity = $$v
        },
        expression: "appraisalreport.entity"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('TIN'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" ")]) : _vm._e()]), _vm._v(" "), (_vm.appraisalreport.entity) ? _c('span', [_vm._v(" " + _vm._s(_vm.appraisalreport.entity.tin) + " ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('BdE_code'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" ")]) : _vm._e()]), _vm._v(" "), (_vm.appraisalreport.entity) ? _c('span', [_vm._v(" " + _vm._s(_vm.appraisalreport.entity.bde_code) + " ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Appraiser')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Name'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.appraiserValue,
        "options": _vm.object_to_array(_vm.appraisers),
        "track-by": "id",
        "label": 'complete_name',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisalreport_appraiser
      },
      model: {
        value: (_vm.appraisalreport.appraiser),
        callback: function($$v) {
          _vm.appraisalreport.appraiser = $$v
        },
        expression: "appraisalreport.appraiser"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('TIN'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" ")]) : _vm._e()]), _vm._v(" "), (_vm.appraisalreport.appraiser) ? _c('span', [_vm._v(" " + _vm._s(_vm.appraisalreport.appraiser.tin) + " ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Prof_assoc_reg_number'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")]), _vm._v(" ")]) : _vm._e()]), _vm._v(" "), (_vm.appraisalreport.appraiser) ? _c('span', [_vm._v(" " + _vm._s(_vm.appraisalreport.appraiser.prof_assoc_reg_number) + " ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Supervisor')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Name'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.supervisorValue,
        "options": _vm.object_to_array(_vm.supervisors),
        "track-by": "id",
        "label": 'complete_name',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisalreport_supervisor
      },
      model: {
        value: (_vm.appraisalreport.supervisor),
        callback: function($$v) {
          _vm.appraisalreport.supervisor = $$v
        },
        expression: "appraisalreport.supervisor"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('TIN'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" ")]) : _vm._e()]), _vm._v(" "), (_vm.appraisalreport.supervisor) ? _c('span', [_vm._v(" " + _vm._s(_vm.appraisalreport.supervisor.tin) + " ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Prof_assoc_reg_number'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")]), _vm._v(" ")]) : _vm._e()]), _vm._v(" "), (_vm.appraisalreport.supervisor) ? _c('span', [_vm._v(" " + _vm._s(_vm.appraisalreport.supervisor.prof_assoc_reg_number) + " ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Real_estates')) + " " + _vm._s(_vm.$t('valuated_in_this_report')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSelectNewRealEstate($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.select_real_estate_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), (_vm.object_length(_vm.appraisalreport_realestates) > 0) ? _c('div', [_c('div', {
      staticClass: "query_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-main",
        "source": _vm._.sortBy(_vm.object_to_array(_vm.appraisalreport_realestates), 'index'),
        "filterable": false,
        "striped": _vm.realestate_table.striped,
        "editable": _vm.realestate_table.editable,
        "line-numbers": _vm.realestate_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-realestates",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editRealEstate(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.discardRealEstate(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "times",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "index",
        fn: function(cell) {
          return [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['index']),
              expression: "cell.row['index']"
            }],
            staticStyle: {
              "width": "40px"
            },
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['index'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'index';
                if (!Array.isArray($$exp)) {
                  cell.row['index'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_entity_index($event, cell.row)
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "property_type",
        fn: function(cell) {
          return [(cell.row['property_type']) ? _c('span', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v(_vm._s(cell.row['property_type']['name_ca']))]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v(_vm._s(cell.row['property_type']['name_en']))]) : _c('span', [_vm._v(_vm._s(cell.row['property_type']['name_es']))])]) : _vm._e()]
        }
      }, {
        key: "appraisal_id",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.realestate_appraisaldateValue,
              "options": _vm.object_to_array(_vm.appraisalreport_realestates[cell.row['id']]['appraisals']),
              "track-by": "id",
              "label": 'id',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_appraisalreport_realestate_appraisal_id($event, cell.row['id'])
              }
            },
            model: {
              value: (cell.row['appraisal_id']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'appraisal_id';
                if (!Array.isArray($$exp)) {
                  cell.row['appraisal_id'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['appraisal_id']"
            }
          })], 1)]
        }
      }, {
        key: "appraisaldate",
        fn: function(cell) {
          return [_c('div', [(cell.row.appraisal_id) ? _c('span', [_vm._v(_vm._s(cell.row.appraisal_id.appraisaldate))]) : _vm._e()])]
        }
      }, {
        key: "realestate_total_adopted_value",
        fn: function(cell) {
          return [_c('div', [(cell.row.appraisal_id) ? _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(cell.row.appraisal_id.realestate_total_adopted_value)) + " €")]) : _vm._e()])]
        }
      }])
    }, [_c('datatable-column', {
      attrs: {
        "id": "actions-realestates",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _vm._l((_vm.realestate_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    })], 2)], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Signature')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.appraisalreport.signature_ap_uid === _vm.user.id || !_vm.appraisalreport.is_ap_signed) ? _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Appraisers_signature')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalreport.is_ap_signed),
        expression: "appraisalreport.is_ap_signed"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisalreport.is_ap_signed) ? _vm._i(_vm.appraisalreport.is_ap_signed, null) > -1 : (_vm.appraisalreport.is_ap_signed)
      },
      on: {
        "click": _vm.set_appraisalreport_is_ap_signed,
        "__c": function($event) {
          var $$a = _vm.appraisalreport.is_ap_signed,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisalreport.is_ap_signed = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisalreport.is_ap_signed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisalreport.is_ap_signed = $$c
          }
        }
      }
    })]) : _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Appraisers_signature')))]), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
      staticClass: "field-group"
    }, [(_vm.appraisalreport.is_ap_signed) ? _c('div', [_c('img', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "src": _vm.appraisalreport.signature_ap_base64,
        "alt": "s"
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.appraisalreport.signature_ap_name))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Signed')) + " " + _vm._s(_vm._f("formatDateAsLocal")(_vm.appraisalreport.signature_ap_date)))])]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.appraisalreport.signature_sv_uid === _vm.user.id || !_vm.appraisalreport.is_sv_signed) ? _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Supervisors_signature')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalreport.is_sv_signed),
        expression: "appraisalreport.is_sv_signed"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisalreport.is_sv_signed) ? _vm._i(_vm.appraisalreport.is_sv_signed, null) > -1 : (_vm.appraisalreport.is_sv_signed)
      },
      on: {
        "click": _vm.set_appraisalreport_is_sv_signed,
        "__c": function($event) {
          var $$a = _vm.appraisalreport.is_sv_signed,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisalreport.is_sv_signed = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisalreport.is_sv_signed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisalreport.is_sv_signed = $$c
          }
        }
      }
    })]) : _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Supervisors_signature')))]), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
      staticClass: "field-group"
    }, [(_vm.appraisalreport.is_sv_signed) ? _c('div', [_c('img', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "src": _vm.appraisalreport.signature_sv_base64,
        "alt": "s"
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.appraisalreport.signature_sv_name))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Signed')) + " " + _vm._s(_vm._f("formatDateAsLocal")(_vm.appraisalreport.signature_sv_date)))])]) : _vm._e()])]), _vm._v(" "), _c('hr')])]), _vm._v(" "), (!this.appraisalreport.title) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.report_title_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm._.size(this.appraisalreport_realestates) < 1) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.realestates_missing_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm._.size(this.appraisalreport_realestates) > 0) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.checkBeforeOnCreatePdf($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "file-pdf-o",
        "text": _vm.pdf_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]) : _vm._e()])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Description')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Appraisal_report_description')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalreport.description),
        expression: "appraisalreport.description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalreport.description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalreport.description = $event.target.value
        }, _vm.set_appraisalreport_description]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Report_number')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Report_number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalreport.number),
        expression: "appraisalreport.number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "maxlength": "2",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalreport.number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalreport.number = $event.target.value
        }, _vm.set_appraisalreport_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Version')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalreport.version),
        expression: "appraisalreport.version"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "maxlength": "2",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalreport.version)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalreport.version = $event.target.value
        }, _vm.set_appraisalreport_version],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Status')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Status')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.statusValue,
        "options": _vm.status_reportsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisalreport_status
      },
      model: {
        value: (_vm.appraisalreport.status),
        callback: function($$v) {
          _vm.appraisalreport.status = $$v
        },
        expression: "appraisalreport.status"
      }
    })], 1)])])])])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentAppraisalReport({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentAppraisalReport({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.appraisalreport.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dc00004c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/appraisalreports/AppraisalReportEditor.vue
// module id = 2193
// module chunks = 0